import config from './config';
import { isPatientAppType, isPatientMobileClient, isPatientPortalWebClient } from './app-utils';
import { isGlobalAud } from './aud-utils';
import constants from './constants';
import { getUnifiedLoginRolloutDecision } from './cookie-utils';

const isGlobalRolledOut = (unifiedPatientLoginRollout) =>
  unifiedPatientLoginRollout === true || getUnifiedLoginRolloutDecision();

const isLoginExperienceNew = (loginExperience) =>
  loginExperience === constants.NEW_LOGIN_EXPERIENCE;

const showPatientLogo = ({ aud, clientId, loginExperience, apiResponse }) => {
  const { appType, unifiedPatientLoginRollout } = apiResponse;
  if (!isPatientAppType(appType) || !config.unifiedPatientLoginEnabled || !config.patientLogoUrl) {
    return false;
  }
  if (isPatientMobileClient(clientId)) {
    return isLoginExperienceNew(loginExperience);
  }
  if (!isPatientPortalWebClient(clientId)) {
    return false;
  }
  return isGlobalAud(aud)
    ? isGlobalRolledOut(unifiedPatientLoginRollout)
    : isLoginExperienceNew(loginExperience);
};

export const fetchLogoProps = ({ idp, aud, clientId, loginExperience, apiResponse = {} }) => {
  if (idp) {
    return {};
  }
  return showPatientLogo({ aud, clientId, loginExperience, apiResponse })
    ? { logoText: 'athenaPatient', logoUrl: config.patientLogoUrl }
    : { logoText: 'athenahealth', logoUrl: config.logoUrl };
};
